import React from "react";
import { useNavigate } from "react-router-dom";
import { ToggleLeft } from "lucide-react";
import { usePlan } from "../../contexts/PlanContext";
import { AppButton, EmptyState } from "../ui";
import Shimmer from "./Shimmer";

const NAMES = {
  advancedProfile: "Advanced student profile",
  contractStudents: "Contract students",
};

/**
 * StudentModuleGate — wraps a route that belongs to one of the two student-
 * profile modules (Settings → Modules). Unlike `PlanGate`, this fails CLOSED:
 * a default-off module must not render its page for the moment before the
 * answer lands, so it shows a skeleton while plan features load and a plain
 * "not switched on" page when the module is off.
 *
 *   <StudentModuleGate module="advancedProfile"><MyProfilePage /></StudentModuleGate>
 */
const StudentModuleGate = ({ module, children }) => {
  const { hasStudentModule, loading } = usePlan();
  const navigate = useNavigate();

  if (loading) return <div className="tw-p-4"><Shimmer height={72} count={4} /></div>;
  if (hasStudentModule(module)) return children;

  return (
    <EmptyState
      icon={ToggleLeft}
      title={`${NAMES[module] || "This module"} is not switched on`}
      description="An administrator can switch it on under Settings → Modules."
      action={<AppButton variant="outline" onClick={() => navigate(-1)}>Go back</AppButton>}
    />
  );
};

export default StudentModuleGate;
